/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import APIRequest from '../api';
const methods = ['get', 'post', 'put', 'patch', 'del'];
/*
 * This silly underscore is here to avoid a mysterious "ReferenceError: ApiClient is not defined" error.
 * See Issue #14. https://github.com/erikras/react-redux-universal-hot-example/issues/14
 *
 * Remove it at your own risk.
 */
class _ApiClient {
  constructor(req) {
    methods.forEach((method) =>
      this[method] = (path, { params, data } = {}) => new Promise((resolve, reject) => {
        return APIRequest(
          method,
          path,
          params,
          data,
          (err, res)=> {
            if (err) {
              reject(err);
            } else {
              resolve(res.body);
            }
          });
      }));
  }
}

const ApiClient = _ApiClient;
export var client = new ApiClient();

export default ApiClient;




// WEBPACK FOOTER //
// ./src/helpers/ApiClient.js